/* eslint-disable */
/* eslint-disable no-param-reassign */
<template>
  <PMain v-model="themeData" :dataKey="key">
    <v-form ref="payForm">
    <v-skeleton-loader v-if="isPageLoading" type="card" />
    <!-- SUB TOTAL BLOCK -->
    <div v-else>
      <v-card
        v-if="
          themeData.paymentBlock && themeData.paymentBlock.data.active && order
        "
        id="select-payment"
        v-bind="themeData.paymentBlock.data.attr"
      >
        <v-card-text>
          <a @click="$router.go(-1)">Back</a>
          <v-row dense>
            <v-col cols="12">
              <v-card>
                <v-card-title>Total Price</v-card-title>
                <v-card-text class="text-center">
                  <h1>
                    {{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ $store.getters["cart/grandTotal"] | formatPrice }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              v-if="
                themeData.customerDetail &&
                themeData.customerDetail.data &&
                themeData.customerDetail.data.active
              "
            >
              <v-card>
                <v-card-title>{{
                  $lt(themeData.customerDetail.data.text)
                }}</v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      v-if="
                        themeData.customerDetail.data.nodes.name.data.active
                      "
                    >
                      <v-text-field
                        :label="
                          $lt(themeData.customerDetail.data.nodes.name.data.text)
                        "
                        outlined
                        dense
                        v-model="formOrder.customer.name"
                        :error-messages="showErrorMessage('customer.name')"
                        v-bind="themeData.customerDetail.data.nodes.name.data.attr"
                        :rules="requiredRule"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="
                        themeData.customerDetail.data.nodes.phone_number.data
                          .active
                      "
                    >
                      <v-text-field
                        :label="
                          $lt(themeData.customerDetail.data.nodes.phone_number.data.text)
                        "
                        outlined
                        dense
                        v-model="formOrder.customer.phone_number"
                        :error-messages="
                          showErrorMessage('customer.phone_number')
                        "
                        v-bind="themeData.customerDetail.data.nodes.phone_number.data.attr"
                        :rules="requiredRule"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="
                        themeData.customerDetail.data.nodes.email.data.active
                      "
                    >
                      <v-text-field
                        :label="
                          $lt(themeData.customerDetail.data.nodes.email.data.text)
                        "
                        outlined
                        dense
                        v-model="formOrder.customer.email"
                        required
                        :error-messages="showErrorMessage('customer.email')"
                        v-bind="themeData.customerDetail.data.nodes.email.data.attr"
                        :rules="emailRule"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              v-if="
                themeData.requestedTime &&
                themeData.requestedTime.data &&
                themeData.requestedTime.data.active
              "
            >
              <v-card>
                <v-card-title>{{
                  $lt(themeData.requestedTime.data.text)
                }}</v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        :label="
                          $lt(themeData.requestedTime.data.nodes.date.data.text)
                        "
                        type="date"
                        v-model="formOrder.requested_time.date"
                        outlined
                        dense
                        v-bind="themeData.requestedTime.data.nodes.date.data.attr"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        :label="
                          $lt(themeData.requestedTime.data.nodes.time.data.text)
                        "
                        type="time"
                        outlined
                        dense
                        v-model="formOrder.requested_time.time"
                        v-bind="themeData.requestedTime.data.nodes.time.data.attr"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>Select Payment</v-card-title>
                <v-card-text>
                  <v-radio-group v-model="form.code" row>
                    <v-radio
                      :value="paymentMethod.code"
                      v-for="(paymentMethod, i) in selectedItems"
                      :key="i"
                    >
                      <template v-slot:label>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <img
                              :src="`/asset/payment/${paymentMethod.code}.svg`"
                              width="40"
                              height="30"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <span>{{ $lt(paymentMethod.text) }}</span>
                        </v-tooltip>
                      </template>
                    </v-radio>
                  </v-radio-group>

                  <v-row v-if="form.code == 'ideal'">
                    <v-col>
                      <v-select
                        v-model="form.options[form.code].issuer"
                        label="Select Bank/ Issuer"
                        :items="issuerList"
                        :loading="isLoadingIssuer"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div v-if="themeData.payNowButton && themeData.payNowButton.data.active">
      <PButton
        v-model="themeData.payNowButton.data"
        :disabled="!isValid || isOrderLoading"
        @click="createOrderAndPay"
        :loading="isOrderLoading"
      />
    </div>
    </div>

    <template
      v-if="
        themeData.subTotalBlock &&
        themeData.subTotalBlock.data &&
        themeData.subTotalBlock.data.active &&
        cartProducts.length > 0
      "
    >
      <v-card v-bind="themeData.subTotalBlock.data.attr">
        <v-list
          v-bind="themeData.subTotalBlock.data.nodes.listItemBlock.data.attr"
        >
          <v-list-item-group>
            <v-list-item class="d-flex">
              <div>{{ $lt(themeData.subTotalBlock.data.textSubTotal) }}</div>
              <v-spacer />
              <div>
                <b>{{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ formatPrice($store.getters["cart/subTotal"]) }}</b>
              </div>
            </v-list-item>
          </v-list-item-group>

          <v-list-item-group
            v-bind="themeData.subTotalBlock.data.nodes.totalBlock.data.attr"
          >
            <v-list-item class="d-flex">
              <div>{{ $lt(themeData.subTotalBlock.data.textTotal) }}</div>
              <v-spacer />
              <div>
                <b>{{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ formatPrice($store.getters["cart/grandTotal"]) }}</b>
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>

      <v-card
        v-if="themeData.orderDataBlock && themeData.orderDataBlock.data.active"
        v-bind="themeData.orderDataBlock.data.attr"
      >
        <v-card-text>
          <v-textarea
            v-if="
              themeData.orderDataBlock.data.nodes.orderRemarkText &&
              themeData.orderDataBlock.data.nodes.orderRemarkText.data.active
            "
            rows="2"
            outlined
            solo
            auto-grow
            v-model="orderData.order_remark"
            v-bind="
              themeData.orderDataBlock.data.nodes.orderRemarkText.data.attr
            "
          />
        </v-card-text>
      </v-card>
    </template>
    <!-- SUB TOTAL BLOCK -->
  </v-form>
  </PMain>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import _ from "lodash";
import PButton from "../components/_render/PButton.vue";
import PMain from "../components/PMain.vue";
import comminMixin from "../mixins/common";
import moment from "moment";
// import AlertError from "./_AlertError.vue";

export default {
  mixins: [comminMixin],
  data: () => ({
    key: "payment",
    themeData: [],
    orderData: {
      order_remark: null,
    },
    emailRule: [(v) => !!v || "Field is required", (v) => !!v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || 'Email is not valid'],
    requiredRule: [(v) => !!v || "Field is required"],
    formOrder: {
      customer: {
        name: "",
        email: "",
        phone_number: "",
        phone: "",
        address: "",
        place: "",
        company: ""
      },
      requested_time: {
        date: "",
        time: "",
      },
    },
    form: {
      code: "",
      options: {
        cash: {},
        ideal: {
          issuer: "",
          redirectUrl: `${window.location.origin}/order-completed?orderId={orderId}&uniqid={uniqid}`,
        },
        pin: {},
        onaccount: {},
      },
    },
    isValid: false,
    isPageLoading: false,
  }),
  components: {
    PButton,
    PMain,
    // AlertError
  },
  created() {
    this.isPageLoading = true;
  },
  async mounted() {
    if (this.$store.getters["cart/getTotalProduct"] == 0) {
      /**
       * return back cart page, if cart is empty (has no product)
       */
      this.$router.push("/cart");
      return;
    }
    this.formOrder.requested_time = {
      date: moment().format("YYYY-MM-DD"),
      time: moment().format("H:mm"),
    };
    this.fetchPaymentMethods({
      is_active: 1,
      parent_id: "",
    });
    this.getAllIssuer();
    if (this.order && this.order.id) {
      await this.getOrder(this.order.id);
    }
    this.isPageLoading = false;
  },
  methods: {
    ...mapActions({
      fetchPaymentMethods: "paymentMethod/getAll",
      getAllIssuer: "payment/getAllIssuer",
      setPaymentMethod: "cart/setPaymentMethod",
      getSession: "session/getByUniqId",
      getOrder: "cart/getOrderById",
    }),
    pick(object, key) {
      return _.pick(object, key);
    },
    async createOrderAndPay() {
      if (!this.$refs.payForm.validate()) {
        return false;
      }
      let payload = {
        ...this.$store.getters["cart/generateOrderPayload"],
      };

      await this.$store
        .dispatch("cart/createPickupOrder", payload)
        .then((response) => {
          console.log("CHECK RESPONSE", response);
          // Smart Menu: the cart page flags the lines and lets them be removed.
          if (response && response.blocked) {
            // A tap made while the order was in flight shares this response,
            // so this can run twice; the second push is NavigationDuplicated.
            this.$router.push("/cart").catch(() => {});
            return false;
          }
          if (
            response &&
            response.data &&
            response.payment_order &&
            response.payment_order.data.checkoutUrl
          ) {
            // handle iDeal (need to refactor in next some requirement changes)
            // this.$router.push(response.payment_order.data.checkoutUrl);
            document.location.href = response.payment_order.data.checkoutUrl;
          } else if (response && response.data) {
            // this.$router.push(`${window.location.origin}/order-completed`);
            document.location.href = `${window.location.origin}/order-completed`;
          } else if (response && response.status >= 400) {
            return false;
          }
        });
    },

    showErrorMessage(key) {
      const errorArray = Object.entries(this.errorData);
      let result = [];
      errorArray
        .filter((arr) => arr[0] == key)
        .forEach((arr, key) => {
          result.push(arr[1].join(" "));
        });
      return result.join(" ");
    },
  },
  computed: {
    ...mapState({
      cartProducts: (state) => state.cart.products,
      cart: (state) => state.cart,
      isOrderLoading: (state) => state.cart.isOrderLoading,
      isOrderError: (state) => state.cart.isError,
      errorData: (state) => state.cart.errorData,
      paymentMethodList: (state) => state.paymentMethod.data,
      isLoadingIssuer: (state) => state.payment.isLoadingIssuer,
      sessionData: (state) => state.session.data,
      order: (state) => state.cart.order,
      customerData: (state) => state.cart.customer,
    }),
    ...mapGetters({
      issuerList: "payment/issuerList",
      orderPayload: "cart/getOrderPayload",
    }),
    ...mapState({
      dbData: (state) => state.theme.data,
    }),
    ...mapGetters({
      generalSetting: "theme/general",
    }),
    dataFromDb() {
      const data = {};
      this.dbData.forEach((item) => {
        data[item.key] = item.value;
      });
      return data;
    },
    selectedItems() {
      return this.themeData.paymentBlock.data.nodes.paymentList.data.items.filter(
        (item) => item
      );
    },
  },
  filters: {
    formatPrice(value) {
      return Number(value).toFixed(2);
    },
  },
  watch: {
    customerData: {
      handler(newValue) {
        this.formOrder.customer = newValue;
      },
      deep: true,
    },
    formOrder: {
      handler(newValue) {
        this.$store.commit("cart/SET_CUSTOMER_DATA", newValue.customer);
        this.$store.commit("cart/SET_REQUESTED_TIME", newValue.requested_time);
      },
      deep: true,
    },
    cartProducts: {
      handler(newValue) {
        if (newValue.length === 0) {
          // this.$router.push("/");
        }
      },
      deep: true,
    },
    form: {
      handler(newValue) {
        const paymentOptions = {
          ...this.form,
          options: {
            ...newValue.options[newValue.code],
          },
        };
        this.setPaymentMethod(paymentOptions);

        let validCount = 0;
        let totalCount = 0;
        Object.entries(newValue.options[newValue.code]).forEach((item) => {
          if (item[1]) {
            validCount++;
          }
          totalCount++;
        });

        if (validCount === totalCount) {
          this.isValid = true;
        } else {
          this.isValid = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
#select-payment .v-input--selection-controls__input {
  visibility: hidden;
  margin: 0 !important;
  padding: 0px;
  width: 0 !important;
}

#select-payment .v-item--active {
  border: 2px solid #fc6020 !important;
  border-radius: 5px;
  margin: 0px;
  padding: 0px;
}

#select-payment .v-radio {
  padding: 6px 5px !important;
  margin: 5px !important;
  border: 1px solid #cfcfcf;
  border-radius: 10px !important;
}

#select-payment .v-radio--is-disabled {
  opacity: 0.5;
}
</style>
